import { FEES } from '../constants';

export const getActiveFeePercentage = (active) => {
  if (active.state.name === 'Colorado') {
    return FEES.find((fee) => fee.id === active.fee.id).percentage;
  } else if (active.state.name === 'Connecticut') {
    return 0.0635; // 6.35%
  }
  return 0;
};
